<template>
  <div class="surveys-component" v-if="isShowSurvey">
    <div v-if="!isShowSurveyDetail">
      <div class="header-page-surveys">
          アンケート
          <div class="button-close-surveys" @click="handleClickHideSurveys"><i class="el-icon-close"></i></div>
      </div>
      <div class="body-surveys">
          <div class="list-surveys">
              <div v-for="(item, index) in surveys" v-if="!item.is_complete" @click="handleClickSurveyItem(item)" class="survey-item" :key="index">
                  <div class="title-survey">
                      {{item.title}}
                  </div>
                  <div class="date-survey">
                    回答期限: {{item.due_date}}
                  </div>
                  <div v-if="item.is_complete" class="alert-complete-survey">済み</div>
              </div>
          </div>
      </div>
    </div>
    <SurveyDetail v-else :survey-item="selectedSurvey" :total-surveys="surveys.length" @hideSurveyDetail="hideSurveyDetail" />
  </div>


</template>

<script>

import {mapActions, mapGetters} from 'vuex'
import moment from 'moment'
import SurveyDetail from '@/components/survey-detail'
import { CAN_SHOW_SURVEY } from '@/config'

export default {
  components: {SurveyDetail},
  data () {
    return {
      isShowSurveyDetail: false,
      selectedSurvey: {},
      isShowSurvey: false
    }
  },
  computed: {
    ...mapGetters({
      surveys: 'surveys/surveys',
      isShowSurveysModal: 'surveys/isShowSurveysModal'
    }),
    canShowSurvey () {
      return CAN_SHOW_SURVEY.indexOf(this.$auth.user().authority) !== -1
    }
  },
  methods: {
    ...mapActions({
      getSurveys: 'surveys/getSurveys',
      setIsShowSurveysModal: 'surveys/setIsShowSurveysModal'
    }),
    handleClickSurveyItem (surveyItem) {
      this.selectedSurvey = surveyItem
      this.isShowSurveyDetail = true
    },
    hideSurveyDetail () {
      this.isShowSurveyDetail = false
    },
    handleClickHideSurveys () {
      this.$emit('hideSurveys')
    },
    dateFormat (date) {
      return moment(date).format('YYYY-MM-DD')
    }
  },
  async mounted () {
    if (this.$auth.user().is_maker && this.canShowSurvey) {
      await this.getSurveys({company_code: this.$auth.user().company_code, status: 1})
      const surveyNotCompleteIndex = this.surveys.findIndex(n => n.is_complete === false)
      if (surveyNotCompleteIndex === -1) {
        this.setIsShowSurveysModal(false)
      }
      this.isShowSurvey = true
    }
  }
}
</script>
<style>
  .el-select-dropdown.el-popper {
    width: calc(100% - 50px);
  }
</style>


// WEBPACK FOOTER //
// src/components/survey.vue